export interface ConsentPreferences {
  necessary: true;
  analytics: boolean;
  advertising: boolean;
  updatedAt: string;
}

export class ConsentService {
  private readonly storageKey = 'kim-converter-consent';

  getPreferences(): ConsentPreferences | null {
    try {
      const storedValue = localStorage.getItem(this.storageKey);
      if (!storedValue) {
        return null;
      }

      const parsedValue = JSON.parse(storedValue) as Partial<ConsentPreferences>;
      return {
        necessary: true,
        analytics: Boolean(parsedValue.analytics),
        advertising: Boolean(parsedValue.advertising),
        updatedAt: typeof parsedValue.updatedAt === 'string' ? parsedValue.updatedAt : new Date().toISOString(),
      };
    } catch {
      return null;
    }
  }

  acceptAll(): ConsentPreferences {
    return this.savePreferences({
      necessary: true,
      analytics: true,
      advertising: true,
      updatedAt: new Date().toISOString(),
    });
  }

  rejectOptional(): ConsentPreferences {
    return this.savePreferences({
      necessary: true,
      analytics: false,
      advertising: false,
      updatedAt: new Date().toISOString(),
    });
  }

  saveOptional(options: Pick<ConsentPreferences, 'analytics' | 'advertising'>): ConsentPreferences {
    return this.savePreferences({
      necessary: true,
      analytics: options.analytics,
      advertising: options.advertising,
      updatedAt: new Date().toISOString(),
    });
  }

  private savePreferences(preferences: ConsentPreferences): ConsentPreferences {
    localStorage.setItem(this.storageKey, JSON.stringify(preferences));
    window.dispatchEvent(new CustomEvent('kim-converter:consent-change', { detail: preferences }));

    return preferences;
  }
}
